// SessionCard.jsx

import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
  Stack,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import dayjs from "dayjs";

const SessionCard = ({ session, onSelect, pricePerPerson }) => {
  const spotsTaken = session.bookings.reduce((sum, b) => sum + b.numSeats, 0);
  const spotsLeft = session.capacity - spotsTaken;
  const isFull = spotsLeft <= 0;

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        minHeight: 450,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}>
      <CardContent>
        {session.title && (
          <Typography variant="h6" fontWeight="bold">
            {session.title}
          </Typography>
        )}
        <Typography variant="body2" sx={{ mb: 1 }}>
          {dayjs(session.date).format("MMMM D, YYYY")} | {session.startTime} –{" "}
          {session.endTime}
        </Typography>

        {session.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {session.description}
          </Typography>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          In this class we will learn:
        </Typography>

        {Array.isArray(session.whatYouWillLearn) &&
          session.whatYouWillLearn.length > 0 && (
            <Box sx={{ mb: 2 }}>
              {session.whatYouWillLearn.map((item, idx) => (
                <Typography
                  key={idx}
                  variant="body2"
                  sx={{ display: "list-item", ml: 2 }}>
                  {item}
                </Typography>
              ))}
            </Box>
          )}

        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <LocationOnIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography variant="body2" color="text.secondary">
            16 Stavanger Dr., St. John's
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <EventSeatIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography
            variant="body2"
            color={
              isFull
                ? "error"
                : spotsLeft <= 2
                ? "warning.main"
                : "text.secondary"
            }>
            {isFull
              ? "Fully booked"
              : `${spotsLeft} spots left of ${session.capacity}`}
          </Typography>
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Price per person: ${pricePerPerson.toFixed(2)} + HST
        </Typography>

        {isFull ? (
          <Chip label="Fully Booked" color="error" />
        ) : (
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelect(session)}>
            Book This Session
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default SessionCard;
